// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"ImageComponent_imageContainer__1zUb4","image":"ImageComponent_image__26J_1"};